export const getNoteText = (text: string) => {
  const data = text.replaceAll(' ', '&ensp;');

  return data;
};
